<p-card header="Walmart Misc Info">
  <div [ngClass]="'showShifts' + showShift">
    <h3>Products Scrapped</h3>


    <p-table [value]="scrapItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Product Type<span class="required">*</span></th>
          <th class="shift1">{{ showShift === 0 ? 'Shift 1' : 'Total'}}<span class="required">*</span></th>
          <th class="shift2">{{ showShift === 0 ? 'Shift 2' : 'Total'}}<span class="required">*</span></th>
          <th class="shift3">{{ showShift === 0 ? 'Shift 3' : 'Total'}}<span class="required">*</span></th>
          <th class="shift4">{{ showShift === 0 ? 'Shift 4' : 'Total'}}<span class="required">*</span></th>
          <th class="shift5">{{ showShift === 0 ? 'Shift 5' : 'Total'}}<span class="required">*</span></th>
          <th>Delete</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
        <tr [formGroup]="rowData">
          <td>
            <p-dropdown [options]="scrapTypes" formControlName="productId" appendTo="body" name="scrapType"
              [required] [filter]="true" [editable]="false"[resetFilterOnHide]="true">
            </p-dropdown>
          </td>
          <td class="shift1">
            <input pInputText type="number" formControlName="handledS1" style="width:100%" name="scrapShift1"
             required>
          </td>
          <td class="shift2">
            <input pInputText type="number" formControlName="handledS2" style="width:100%" name="scrapShift2"
             required>
          </td>
          <td class="shift3">
            <input pInputText type="number" formControlName="handledS3" style="width:100%" name="scrapShift3"
             required>
          </td>
          <td class="shift4">
            <input pInputText type="number" formControlName="handledS4" style="width:100%" name="scrapShift4"
             required>
          </td>
          <td class="shift5">
            <input pInputText type="number" formControlName="handledS5" style="width:100%" name="scrapShift5"
             required>
          </td>
          <td>
            <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
              confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle" cancelText="Cancel"
              (actionConfirmed)="deleteHandling(rowData)" [disabled]="scrapAddForm.disabled">
            </confirmation-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="7" class="centered">
            No data available
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-rowData>
        <tr [formGroup]="scrapAddForm">
          <td>
            <p-dropdown [options]="scrapTypes" [required] appendTo="body" placeholder="-- Select Product Type --" inputId="productType"
              class="form-control" name="productType" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
            </p-dropdown>
            <error-block [field]="scrapAddForm.controls.productId" [messages]="{
                required: 'Product Type is required.'
              }">
            </error-block>
          </td>
          <td class="shift1">
            <input type="number" lib-numeric pInputText id="bsShift1" required name="bsShift1" class="form-control" formControlName="handledS1"/>
            <error-block [field]="scrapAddForm.controls.handledS1" [messages]="{
                required: 'Shift 1 is required.'
              }">
            </error-block>
          </td>
          <td class="shift2">
            <input type="number" lib-numeric pInputText id="bsShift2" required name="bsShift2" class="form-control" formControlName="handledS2"/>
            <error-block [field]="scrapAddForm.controls.handledS2" [messages]="{
                required: 'Shift 2 is required.'
              }">
            </error-block>
          </td>
          <td class="shift3">
            <input type="number" lib-numeric pInputText id="bsShift3" required name="bsShift3" class="form-control" formControlName="handledS3"/>
            <error-block [field]="scrapAddForm.controls.handledS3" [messages]="{
                required: 'Shift 3 is required.'
              }">
            </error-block>
          </td>
          <td class="shift4">
            <input type="number" lib-numeric pInputText id="bsShift4" required name="bsShift4" class="form-control" formControlName="handledS4"/>
            <error-block [field]="scrapAddForm.controls.handledS4" [messages]="{
                required: 'Shift 4 is required.'
              }">
            </error-block>
          </td>
          <td class="shift5">
            <input type="number" lib-numeric pInputText id="bsShift5" required name="bsShift5" class="form-control" formControlName="handledS5"/>
            <error-block [field]="scrapAddForm.controls.handledS5" [messages]="{
                required: 'Shift 5 is required.'
              }">
            </error-block>
          </td>
          <td>
            <button type="button" pButton
              icon="pi pi-plus"
              iconPos="left"
              (click)="createScrapItem();"
              label="Add"
              [ngClass]="{ 'p-state-disabled': !scrapAddForm.valid }"
              [disabled]="scrapAddForm.disabled"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="horAlignment">
      <form [formGroup]="walmartMiscInfoForm" *ngIf="showTpmMaintenanceOnlyRepairs">
        <h3>Maintenance Only Repairs</h3>

        <div class="p-grid">
          <div class="form-group p-col-2 shift1" >
            <label class="required" for="maintenanceOnlyRepairsS1">{{ showShift === 0 ? 'Shift 1' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="maintenanceOnlyRepairsS1"
                   formControlName="maintenanceOnlyRepairsS1" lib-numeric>
            <error-block [field]="walmartMiscInfoForm.controls.maintenanceOnlyRepairsS1" [messages]="{
                required: 'Shift 1 is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col-2 shift2" >
            <label class="required" for="maintenanceOnlyRepairsS2">{{ showShift === 0 ? 'Shift 2' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="maintenanceOnlyRepairsS2"
                   formControlName="maintenanceOnlyRepairsS2" lib-numeric>
            <error-block [field]="walmartMiscInfoForm.controls.maintenanceOnlyRepairsS2" [messages]="{
                required: 'Shift 2 is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col-2 shift3" >
            <label class="required" for="maintenanceOnlyRepairsS3">{{ showShift === 0 ? 'Shift 3' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="maintenanceOnlyRepairsS3"
                   formControlName="maintenanceOnlyRepairsS3" lib-numeric>
            <error-block [field]="walmartMiscInfoForm.controls.maintenanceOnlyRepairsS3" [messages]="{
                required: 'Shift 3 is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col-2 shift4" >
            <label class="required" for="maintenanceOnlyRepairsS4">{{ showShift === 0 ? 'Shift 4' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="maintenanceOnlyRepairsS4"
                   formControlName="maintenanceOnlyRepairsS4" lib-numeric>
            <error-block [field]="walmartMiscInfoForm.controls.maintenanceOnlyRepairsS4" [messages]="{
                required: 'Shift 4 is required.'
              }"></error-block>
          </div>
          <div class="form-group p-col-2 shift5" >
            <label class="required" for="maintenanceOnlyRepairsS5">{{ showShift === 0 ? 'Shift 5' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="maintenanceOnlyRepairsS5"
                   formControlName="maintenanceOnlyRepairsS5" lib-numeric>
            <error-block [field]="walmartMiscInfoForm.controls.maintenanceOnlyRepairsS5" [messages]="{
                required: 'Shift 5 is required.'
              }"></error-block>
          </div>
        </div>
      </form>

      <form *ngIf="hasWWRepair" [formGroup]="wwPalletsRepairedForm">
        <h3>White Wood Pallets Repaired</h3>

        <div class="p-grid">
          <div class="form-group p-col-2 shift1" >
            <label class="required" for="wwPalletsRepairedS1">{{ showShift === 0 ? 'Shift 1' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="wwPalletsRepairedS1"
                  formControlName="handledS1" lib-numeric>
            <error-block [field]="wwPalletsRepairedForm.controls.handledS1" [messages]="{
                  required: 'Shift 1 is required.'
                }"></error-block>
          </div>
          <div class="form-group p-col-2 shift2" >
            <label class="required" for="wwPalletsRepairedS2">{{ showShift === 0 ? 'Shift 2' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="wwPalletsRepairedS2"
                  formControlName="handledS2" lib-numeric>
            <error-block [field]="wwPalletsRepairedForm.controls.handledS2" [messages]="{
                  required: 'Shift 2 is required.'
                }"></error-block>
          </div>
          <div class="form-group p-col-2 shift3" >
            <label class="required" for="wwPalletsRepairedS3">{{ showShift === 0 ? 'Shift 3' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="wwPalletsRepairedS3"
                  formControlName="handledS3" lib-numeric>
            <error-block [field]="wwPalletsRepairedForm.controls.handledS3" [messages]="{
                  required: 'Shift 3 is required.'
                }"></error-block>
          </div>
          <div class="form-group p-col-2 shift4" >
            <label class="required" for="wwPalletsRepairedS4">{{ showShift === 0 ? 'Shift 4' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="wwPalletsRepairedS4"
                  formControlName="handledS4" lib-numeric>
            <error-block [field]="wwPalletsRepairedForm.controls.handledS4" [messages]="{
                  required: 'Shift 4 is required.'
                }"></error-block>
          </div>
          <div class="form-group p-col-2 shift5" >
            <label class="required" for="wwPalletsRepairedS5">{{ showShift === 0 ? 'Shift 5' : 'Total' }}</label>
            <input type="number" pInputText class="form-control chepInput" id="wwPalletsRepairedS5"
                  formControlName="handledS5" lib-numeric>
            <error-block [field]="wwPalletsRepairedForm.controls.handledS5" [messages]="{
                  required: 'Shift 5 is required.'
                }"></error-block>
          </div>
        </div>
      </form>

      <h3>RPCs Sorted</h3>

      <p-table [value]="rpcSortedItems" dataKey="controls.id.value" [rowTrackBy]="rowTrackBy" [autoLayout]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>RPC Type<span class="required">*</span></th>
            <th class="shift1">{{ showShift === 0 ? 'Shift 1' : 'Total' }}<span class="required">*</span></th>
            <th class="shift2">{{ showShift === 0 ? 'Shift 2' : 'Total' }}<span class="required">*</span></th>
            <th class="shift3">{{ showShift === 0 ? 'Shift 3' : 'Total' }}<span class="required">*</span></th>
            <th class="shift4">{{ showShift === 0 ? 'Shift 4' : 'Total' }}<span class="required">*</span></th>
            <th class="shift5">{{ showShift === 0 ? 'Shift 5' : 'Total' }}<span class="required">*</span></th>
            <th>Delete</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
          <tr [formGroup]="rowData">
            <td>
              <p-dropdown [options]="rpcTypes" formControlName="productId" appendTo="body" name="rpcType"
                          [required] [filter]="true" [editable]="false" [resetFilterOnHide]="true">
              </p-dropdown>
            </td>
            <td class="shift1">
              <input pInputText type="number" formControlName="handledS1" style="width:100%" name="rpcSortedShift1"
                   required>
            </td>
            <td class="shift2">
              <input pInputText type="number" formControlName="handledS2" style="width:100%" name="rpcSortedShift2"
                   required>
            </td>
            <td class="shift3">
              <input pInputText type="number" formControlName="handledS3" style="width:100%" name="rpcSortedShift3"
                   required>
            </td>
            <td class="shift4">
              <input pInputText type="number" formControlName="handledS4" style="width:100%" name="rpcSortedShift4"
                   required>
            </td>
            <td class="shift5">
              <input pInputText type="number" formControlName="handledS5" style="width:100%" name="rpcSortedShift5"
                   required>
            </td>
            <td>
              <confirmation-button [iconsOnly]="true" actionIcon="pi pi-times" actionText="Delete"
                                  confirmIcon="pi pi-times" confirmText="Delete" cancelIcon="pi pi-minus-circle" cancelText="Cancel"
                                  (actionConfirmed)="deleteHandling(rowData)" [disabled]="rpcSortedAddForm.disabled">
              </confirmation-button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="7" class="centered">
              No data available
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer" let-rowData>
          <tr [formGroup]="rpcSortedAddForm">
            <td>
              <p-dropdown [options]="rpcTypes" [required] appendTo="body" placeholder="-- Select RPC Type --" inputId="rpcType"
                          class="form-control" name="rpcType" [filter]="true" [editable]="false" [resetFilterOnHide]="true" formControlName="productId">
              </p-dropdown>
              <error-block [field]="rpcSortedAddForm.controls.productId" [messages]="{
                required: 'RPC Type is required.'
              }">
              </error-block>
            </td>
            <td class="shift1">
              <input type="number" lib-numeric pInputText id="rpcShift1" required name="rpcShift1" class="form-control" formControlName="handledS1"/>
              <error-block [field]="rpcSortedAddForm.controls.handledS1" [messages]="{
                required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td class="shift2">
              <input type="number" lib-numeric pInputText id="rpcShift2" required name="rpcShift1" class="form-control" formControlName="handledS2"/>
              <error-block [field]="rpcSortedAddForm.controls.handledS2" [messages]="{
                required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td class="shift3">
              <input type="number" lib-numeric pInputText id="rpcShift3" required name="rpcShift1" class="form-control" formControlName="handledS3"/>
              <error-block [field]="rpcSortedAddForm.controls.handledS3" [messages]="{
                required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td class="shift4">
              <input type="number" lib-numeric pInputText id="rpcShift4" required name="rpcShift1" class="form-control" formControlName="handledS4"/>
              <error-block [field]="rpcSortedAddForm.controls.handledS4" [messages]="{
                required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td class="shift5">
              <input type="number" lib-numeric pInputText id="rpcShift5" required name="rpcShift1" class="form-control" formControlName="handledS5"/>
              <error-block [field]="rpcSortedAddForm.controls.handledS5" [messages]="{
                required: 'Count is required.'
              }">
              </error-block>
            </td>
            <td>
              <button type="button" pButton icon="pi pi-plus" iconPos="left" (click)="saveRSI();" label="Add" [ngClass]="{ 'p-state-disabled': !rpcSortedAddForm.valid }" [disabled]="rpcSortedAddForm.disabled"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card>
